import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {Uppy} from "@uppy/core";
import DropTarget from "@uppy/drop-target";
import Dashboard from "@uppy/dashboard";
import XHRUpload from "@uppy/xhr-upload";
import {tokenGetter} from "../app.module";

@Injectable({
  providedIn: 'root'
})
export class UppyFactory {
  public static create(): Uppy {
    return new Uppy({
      debug: false,
      autoProceed: true,
      restrictions: {
        allowedFileTypes: [
          'image/*',
          '.pdf',
          '.mp3',
          'audio/*'
        ]
      }
    })
      .use(DropTarget, {
        target: document.body,
      })
      .use(Dashboard, {
        inline: true,
        width: "100%",
        height: "100%",
        target: '#upload-files',
        hideUploadButton: true,
        proudlyDisplayPoweredByUppy: false,
        onRequestCloseModal: () => {
        }
      })
      .use(XHRUpload, {
        endpoint: environment.api.url + '/ui/v1/file',
        headers: {
          Authorization: `Bearer ${tokenGetter()}`
        },
        //       h    m    s    ms
        timeout: 24 * 60 * 60 * 1000
      })
      .on('upload-success', (result, response) => {
      });
  }
}
